import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { LOCIZE_NAMESPACE } from 'main/common'
import { i18nKeyPrefix as PRE } from '../../.'
import {
  FeatureDescriptionText,
  FeatureItemContainer,
  FeaturesContainer,
  FeatureTitle,
  Icon,
  IconContainer,
  SectionContainer,
  SectionDescriptionText,
  SectionTitle,
} from './Features.styles'

export default function Features() {
  const { t } = useTranslation(LOCIZE_NAMESPACE)
  const features = [
    {
      title: `${PRE}-FEATURES-PROGRAM-TOOLS-TITLE`,
      description: `${PRE}-FEATURES-PROGRAM-TOOLS-TXT`,
      icon: 'https://ucarecdn.com/f9680e53-607a-4b86-88b6-84db0ff7dcc4/',
    },
    {
      title: `${PRE}-FEATURES-PARENT-COMMUNICATION-TITLE`,
      description: `${PRE}-FEATURES-PARENT-COMMUNICATION-TXT`,
      icon: 'https://ucarecdn.com/9e99d801-b0c8-4050-85f7-0b86437f1b29/',
    },
    {
      title: `${PRE}-FEATURES-PEER-COMMUNITY-TITLE`,
      description: `${PRE}-FEATURES-PEER-COMMUNITY-TXT`,
      icon: 'https://ucarecdn.com/a05f6049-be78-4ed9-841d-02a6c602b63a/',
    },
  ]

  return (
    <SectionContainer>
      <SectionTitle>{t(`${PRE}-FEATURES-TITLE`)}</SectionTitle>
      <SectionDescriptionText>{t(`${PRE}-FEATURES-DESCRIPTION-TXT`)}</SectionDescriptionText>
      <FeaturesContainer>
        {features.map(item => renderFeatureItem(item.title, item.description, item.icon))}
      </FeaturesContainer>
    </SectionContainer>
  )

  function renderFeatureItem(title: string, description: string, icon: any) {
    return (
      <FeatureItemContainer key={title}>
        <IconContainer>
          <Icon src={icon} />
        </IconContainer>
        <FeatureTitle>{t(title)}</FeatureTitle>
        <FeatureDescriptionText>{t(description)}</FeatureDescriptionText>
      </FeatureItemContainer>
    )
  }
}
